import {RefObject, useEffect, useRef} from 'react';

import {ProgressRef} from './';

type UseProgressBarReturnType = RefObject<ProgressRef>;

const useProgressBar = (
    currentProgress: number = 0,
    maxProgress: number = 1,
): UseProgressBarReturnType => {
    const ref = useRef<ProgressRef>(null);
    useEffect(() => {
        if (!ref.current) return;
        if (currentProgress) {
            ref.current.setProgress((currentProgress / maxProgress) * 100);
        } else {
            ref.current.setProgress(0);
        }
    }, [currentProgress, maxProgress]);
    return ref;
};

export default useProgressBar;
